/**
 * SPRINT V3 — Dynamic Match Hashtag.
 * Deterministic per-match hashtag (#MEXvsARG_HOY, #SS2026_MEXARG) usable
 * across share copy. Pure helper, no I/O.
 */
export interface HashtagInput {
  matchId?: string | null;
  homeCode?: string | null;
  awayCode?: string | null;
  stage?: string | null; // "octavos", "final", etc.
}

function clean(s: string | null | undefined, fallback = ""): string {
  if (!s) return fallback;
  return s.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6);
}

export function buildMatchHashtags(input: HashtagInput): string[] {
  const home = clean(input.homeCode, "HOME");
  const away = clean(input.awayCode, "AWAY");
  const primary = `#${home}vs${away}_HOY`;
  const branded = `#SS2026_${home}${away}`;
  const stage = input.stage ? `#${clean(input.stage)}_SS2026` : "#Mundial2026";
  return [primary, branded, stage];
}

export function formatHashtagBlock(input: HashtagInput): string {
  return buildMatchHashtags(input).join(" ");
}
